import { render, staticRenderFns } from "./ZhuYuanBaoGaoDetail.vue?vue&type=template&id=69028fe5&scoped=true&"
import script from "./ZhuYuanBaoGaoDetail.vue?vue&type=script&lang=js&"
export * from "./ZhuYuanBaoGaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZhuYuanBaoGaoDetail.vue?vue&type=style&index=0&id=69028fe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69028fe5",
  null
  
)

export default component.exports